module.exports = __webpack_public_path__ + "static/media/hero.f9e898b3.png";